export const carModelsData: { [key: string]: string[] } = {
  toyota: [
    "86",
    "AQUA",
    "Allex",
    "Allion",
    "Alphard",
    "Altezza",
    "Altezza Gita",
    "Aristo",
    "Auris",
    "Avalon",
    "Avensis Sedan",
    "Avensis Wagon",
    "Belta",
    "Blade",
    "Blizzard",
    "Brevis",
    "C-HR",
    "Caldina",
    "Caldina Van",
    "Cami",
    "Camroad",
    "Camry",
    "Camry Gracia",
    "Camry Gracia Wagon",
    "Carina",
    "Carina ED",
    "Celica",
    "Celsior",
    "Century",
    "Chaser",
    "Coaster",
    "Comfort",
    "Corolla",
    "Corolla Axio",
    "Corolla Cross",
    "Corolla Fielder",
    "Corolla Levin",
    "Corolla Rumion",
    "Corolla Runx",
    "Corolla Spacio",
    "Corolla Sport",
    "Corolla Touring",
    "Corolla Van",
    "Corolla Wagon",
    "Corona",
    "Corona Exiv",
    "Corona Mark2",
    "Corona Premio",
    "Corona Van",
    "Corsa",
    "Cresta",
    "Crown",
    "Crown Confort",
    "Crown Esrate",
    "Crown Majesta",
    "Crown Van",
    "Crown Wagon",
    "Deliboy",
    "Duet",
    "Dyna",
    "Esquire",
    "Estima",
    "Estima Emina",
    "Estima Hybrid",
    "Estima Lucida",
    "Estima T/L",
    "FJ Curiser",
    "Funcargo",
    "Gaia",
    "Granace",
    "Grand Hiace",
    "Granvia",
    "Harrier",
    "Hiace Commuter",
    "Hiace Regius",
    "Hiace Truck",
    "Hiace Van",
    "Hiace Wagon",
    "Hilux",
    "Hilux Surf",
    "Hilux Van",
    "Ipsum",
    "Isis",
    "Ist",
    "JPN TAXI",
    "Kluger",
    "LS",
    "Land Cruiser",
    "Land Cruiser Prado",
    "Land Cruiser Wagon",
    "Liteace Noah",
    "Liteace Truck",
    "Liteace VAN",
    "Liteace Wagon",
    "MIRAI",
    "MR-S",
    "MR2",
    "Mark2",
    "Mark2 Bilt",
    "Mark2 Qualis",
    "Mark2 Van",
    "Mark2 Wagon",
    "MarkX",
    "MarkX Zio",
    "Nadia",
    "Noah",
    "Opa",
    "Origin",
    "Passo",
    "Passo Sette",
    "Pixis Epoch",
    "Pixis Joy",
    "Pixis Mega",
    "Pixis Space",
    "Pixis Truck",
    "Pixis Van",
    "Platz",
    "Porte",
    "Premio",
    "Prius",
    "Prius PHV",
    "Prius α",
    "Probox",
    "Probox Van",
    "Progres",
    "Pronard",
    "Publica",
    "QuickDelivery Van",
    "RAV4",
    "RAV4 4WD",
    "Ractis",
    "Raize",
    "Raum",
    "Regius ace Commuter",
    "Regius ace Van",
    "Roomy",
    "Rush",
    "SAI",
    "Scepter Wagon",
    "Sera",
    "Sienta",
    "Soarer",
    "Spade",
    "Sparky",
    "Sprinter",
    "Sprinter Carib",
    "Sprinter Trueno",
    "Sprinter Van",
    "Starlet",
    "Succeed",
    "Succeed Van",
    "Supra",
    "Tank",
    "Touring Hiace",
    "Townace Noah",
    "Townace Truck",
    "Townace Van",
    "Townace Wagon",
    "Toyoace",
    "Toyota",
    "Toyota Classic",
    "Toyota Copen",
    "Toyota Forklift",
    "Urban Supporter",
    "Vanguard",
    "Vellfire",
    "Verossa",
    "Vista",
    "Vitz",
    "Voltz",
    "Voxy",
    "WILL CYPHA",
    "WILL VS",
    "WiLL Vi",
    "Windom",
    "Wish",
    "Yaris",
    "Yaris Cross",
    "bB",
    "iQ",
    "ｱﾙﾌｧｰﾄﾞ ﾊｲﾌﾞﾘｯﾄﾞ 4WD",
    "ｱﾙﾌｧｰﾄﾞV",
    "ｱﾙﾌｧｰﾄﾞV 4WD",
    "ｶﾛｰﾗｸﾛｽ ﾊｲﾌﾞﾘｯﾄﾞ",
    "ｸﾗｳﾝ ｾﾀﾞﾝ",
    "ｸﾗｳﾝｸﾛｽｵｰﾊﾞｰ",
    "ｸﾗｳﾝﾊｲﾌﾞﾘｯﾄﾞ",
    "ｺﾑｽ",
    "ﾀﾞｲﾅﾄﾗｯｸ",
    "ﾉｱ 4WD",
    "ﾊｲｴｰｽﾊﾞﾝ 2WD",
    "ﾊﾘｱｰﾊｲﾌﾞﾘｯﾄﾞ",
    "ﾋﾟｸｼｽﾒｶﾞ",
    "ﾌﾟﾘｳｽα",
    "ﾗﾝﾄﾞｸﾙｰｻﾞｰﾊﾞﾝ",
    "ﾚｸｻｽ NX450h+ AWD",
  ],
  lexus: [
    "Lexus",
    "Lexus CT",
    "Lexus ES",
    "Lexus GS",
    "Lexus GS F",
    "Lexus HS",
    "Lexus IS",
    "Lexus LC",
    "Lexus LS",
    "Lexus LX",
    "Lexus NX",
    "Lexus RC",
    "Lexus RC F",
    "Lexus RX",
    "Lexus SC",
    "Lexus UX",
    "Lexus RZ",
  ],
  nissan: [
    "180SX",
    "AD Van",
    "ARIYA",
    "AURA",
    "Atlas",
    "Avenir Cargo",
    "Bassara",
    "Be-1",
    "Big Thumb",
    "Bluebird",
    "Bluebird Sylphy",
    "Caravan Bus",
    "Caravan Coach",
    "Caravan Van",
    "Cedric",
    "Cedric Van",
    "Cedric Wagon",
    "Cefiro",
    "Cherry",
    "Cima",
    "Civilian",
    "Clipper",
    "Clipper Rio",
    "Clipper Truck",
    "Clipper Van",
    "Condor",
    "Crue",
    "Cube",
    "Cube Cubic",
    "DATSUN PickUp",
    "DAYZ",
    "DAYZ Roox",
    "Datsun",
    "Dualis",
    "Elgrand",
    "Exa",
    "Fairlady",
    "Fairlady Z",
    "Figaro",
    "Fuga",
    "GT-R",
    "Gloria",
    "Gloria Wagon",
    "Homy Corch",
    "Homy Van",
    "Infiniti",
    "Infiniti Q45",
    "Juke",
    "KIX",
    "Lafesta",
    "Largo",
    "Latio",
    "Laurel",
    "Leaf",
    "Leopard",
    "Liberty",
    "March",
    "Maxima",
    "Micra",
    "Mistral",
    "Moco",
    "Murano",
    "NT100ｸﾘｯﾊﾟｰ 4WD",
    "NT100ｸﾘｯﾊﾟｰﾄﾗｯｸ",
    "NV100ｸﾘｯﾊﾟｰ",
    "NV100ｸﾘｯﾊﾟｰﾘｵ",
    "NV200",
    "NV200ﾊﾞﾈｯﾄﾊﾞﾝ",
    "NV200ﾊﾞﾈｯﾄﾜｺﾞﾝ",
    "NV350ｷｬﾗﾊﾞﾝ",
    "NV350ｷｬﾗﾊﾞﾝﾊﾞﾝ",
    "Nissan",
    "Nissan Bus",
    "Nissan Truck",
    "Note",
    "Otti",
    "Pao",
    "Pino",
    "Prairie",
    "Presage",
    "President",
    "Primera",
    "Primera Wagon",
    "Pulsar",
    "Quon",
    "Rasheen",
    "Rnessa",
    "Roox",
    "SAKURA",
    "SYLPHY",
    "Safari",
    "Safari Van",
    "Serena",
    "Serena Cargo",
    "Silvia",
    "Skyline",
    "Skyline Coupe",
    "Skyline CrossOver",
    "Skyline Van",
    "Skyline Wagon",
    "Stagea",
    "Stanza",
    "Sunny",
    "Sunny California",
    "Sunny Lucino",
    "Sunny Truck",
    "Teana",
    "Terrano",
    "Terrano Regulus",
    "Tiida",
    "Tiida Latio",
    "UD",
    "UD Bus",
    "Vanette Coach",
    "Vanette Truck",
    "Vanette Van",
    "Wingroad",
    "X-Trail",
    "ｶｾﾞｯﾄ",
    "ｷｬﾗﾊﾞﾝV 1.2t 2WD",
    "ｽﾍﾟｰｽｱﾛｰ",
    "ｽﾍﾟｰｽﾗﾝﾅｰ",
    "ｾﾚﾅ Sﾊｲﾌﾞﾘｯﾄﾞ",
    "ﾃﾞｨｰｾﾞﾙ",
  ],
  honda: [
    "Accord",
    "Accord Wagon",
    "Acty Streat",
    "Acty Truck",
    "Acty Van",
    "Airwave",
    "Beat",
    "CR-V",
    "CR-Vﾊｲﾌﾞﾘｯﾄﾞ",
    "CR-X",
    "CR-X delSol",
    "CR-Z",
    "Capa",
    "City",
    "Civic",
    "Civic Ferio",
    "Civic Hybrid",
    "Civic Pro",
    "Clarity",
    "Crossroad",
    "Domani",
    "Edix",
    "Element",
    "Elysion",
    "Fit",
    "Fit Shuttle",
    "Freed",
    "Freed Spike",
    "Grace",
    "HR-V",
    "Honda",
    "Honda e",
    "Insight",
    "Inspire",
    "Integra",
    "Jade",
    "Lagreat",
    "Legend",
    "Life",
    "Life Dunk",
    "Logo",
    "MDX",
    "Mobilio",
    "N BOX",
    "N BOX +",
    "N BOX SLASH",
    "N BOX ｶｽﾀﾑ",
    "N BOX ｶｽﾀﾑ 4WD",
    "N ONE",
    "N VAN",
    "N WGN",
    "N-BOX",
    "N-ONE",
    "N-VAN",
    "N-VAN 4WD",
    "N360",
    "NBOX",
    "NONE",
    "NSX",
    "Odyssey",
    "Partner",
    "Prelude",
    "Rafarlgar",
    "S-MX",
    "S2000",
    "S600",
    "S660",
    "S800",
    "Saber",
    "Shuttle",
    "Spike",
    "Stepwgn",
    "Stream",
    "That's",
    "Today",
    "Today Associe",
    "Today Van",
    "Torneo",
    "VEZEL",
    "Vamos",
    "Z",
    "ZR-V",
    "ZR-Vﾊｲﾌﾞﾘｯﾄﾞ",
    "Zest",
    "ｳﾞｪｾﾞﾙ ﾊｲﾌﾞﾘｯﾄﾞ",
    "ｵﾃﾞｯｾｲ e:HEV",
    "ｸﾞﾚｲｽ ﾊｲﾌﾞﾘｯﾄﾞ",
    "ｽﾃｯﾌﾟﾜｺﾞﾝ ｽﾊﾟｰﾀﾞ",
    "ﾌｨｯﾄ ﾊｲﾌﾞﾘｯﾄﾞ",
    "ﾌﾘｰﾄﾞ+ﾊｲﾌﾞﾘｯﾄ",
  ],
  mitsubishi: [
    "Aero Ace",
    "Aero Midi",
    "Aero Quenn",
    "Aero Star",
    "Airtrek",
    "Canter",
    "Canter Guts",
    "Chariot Grandis",
    "Colt",
    "Colt Plus",
    "Debonair",
    "Delica D2",
    "Delica D3",
    "Delica D5",
    "Delica Space Gear",
    "Delica Truck",
    "Delica Van",
    "Delica Wagon",
    "Diamante",
    "Diamante Wagon",
    "Dingo",
    "Dion",
    "Eclipse",
    "Eclipse Cross",
    "FTO",
    "Fuso Bus",
    "Fuso Fighter",
    "Fuso Truck",
    "GTO",
    "Galant",
    "Galant Fortis",
    "Grandis",
    "Great",
    "Jeep",
    "Lancer",
    "Lancer Cedia Wagon",
    "Lancer Van",
    "Lancer Wagon",
    "Legnum",
    "Libero Cargo",
    "Minica",
    "Minica Van",
    "Minicab Miev",
    "Minicab Truck",
    "Minicab Van",
    "Minika Toppo",
    "Minika Toppo Van",
    "Miniyon",
    "Mirage",
    "Mitubishi",
    "Mitubishi Bus",
    "Mitubishi Forklift",
    "Outlander",
    "Outlander PHEV",
    "Pajero",
    "Pajero Jr",
    "Pajero io",
    "Pajero mini",
    "RVR",
    "Rosa",
    "Siguma",
    "Starion",
    "Strada",
    "Super Great",
    "Toppo",
    "Toppo BJ",
    "Town Box",
    "Triton",
    "eKｸﾛｽ ｽﾍﾟｰｽ",
    "eKｽﾍﾟｰｽ 4WD",
    "eKﾜｺﾞﾝ",
    "eKﾜｺﾞﾝ 4WD",
    "ek Active",
    "ek Classy",
    "ek Custom",
    "ek Space",
    "ek Sports",
    "ek Wagon",
    "ek X",
    "ekｸﾛｽ EV",
    "ekｸﾛｽ ｽﾍﾟｰｽ",
    "i",
    "i-Miev",
    "ﾃﾞﾘｶ D:5 4WD",
    "ﾃﾞﾘｶ ﾐﾆ",
    "ﾃﾞﾘｶD:2",
    "ﾃﾞﾘｶｽﾀｰﾜｺﾞﾝ",
    "ﾃﾞﾘｶﾐﾆ",
    "ﾌｧｲﾀ-",
    "ﾐﾆｷｬﾌﾞﾄﾗｯｸ 4WD",
    "ﾐﾆｷｬﾌﾞﾊﾞﾝ 4WD",
  ],
  mazda: [
    "AZ Offroad",
    "AZ Wagon",
    "AZ-1",
    "Atenza Sedan",
    "Atenza Sports",
    "Atenza Wagon",
    "Axela",
    "Biante",
    "Bongo Brawny AFT",
    "Bongo Brawny Truck",
    "Bongo Brawny Van",
    "Bongo Friendee",
    "Bongo Truck",
    "Bongo Van",
    "Bongo Wagon",
    "CX-3",
    "CX-30",
    "CX-5",
    "CX-5 4WD",
    "CX-60",
    "CX-7",
    "CX-8",
    "Capella Cargo",
    "Capella Wagon",
    "Carol",
    "Chante",
    "Cosmo",
    "Demio",
    "Eunos 800",
    "Eunos Cosmo",
    "Familia",
    "Familia S Wagon",
    "Familia Van",
    "Flair",
    "Flair Wagon",
    "Laputa",
    "Luce",
    "MAZDA2",
    "MAZDA3",
    "MAZDA3 ﾌｧｽﾄﾊﾞｯｸ",
    "MAZDA6",
    "MPV",
    "MX-30",
    "Mazda",
    "Porter-Cab",
    "Premacy",
    "Proceed",
    "Proceed Levante",
    "Proceed Marvie",
    "RX-7",
    "RX-8",
    "Roadster",
    "Savanna",
    "Scrum Truck",
    "Scrum Van",
    "Scrum Wagon",
    "Sentia",
    "Spiano",
    "Titan",
    "Tribute",
    "Verisa",
    "ｱｸｾﾗｽﾎﾟｰﾂ",
    "ｽｸﾗﾑﾄﾗｯｸ 4WD",
    "ｽｸﾗﾑﾊﾞﾝ 4WD",
    "ﾀｲﾀﾝﾄﾗｯｸ",
    "ﾌﾚｱ ｶｽﾀﾑｽﾀｲﾙ 4WD",
    "ﾌﾚｱｸﾛｽｵｰﾊﾞｰ",
    "ﾎﾞﾝｺﾞﾄﾗｯｸ 1.15t 2WD",
    "ﾎﾞﾝｺﾞﾄﾗｯｸ 2WD",
    "ﾏﾂﾀﾞ2",
    "ﾛｰﾄﾞｽﾀｰRF",
  ],
  suzuki: [
    "Alto",
    "Alto Eco",
    "Alto Lapin",
    "Alto Van",
    "Alto Works",
    "Baleno",
    "Captino",
    "Caravan",
    "Carry Truck",
    "Cervo",
    "Cervo Mode",
    "Chevrolet Cruze",
    "Chevrolet MW",
    "Cultus Crescent",
    "Escudo",
    "Escudo Nomad",
    "Every",
    "Every Landy",
    "Every Plus",
    "Every Wagon",
    "Fronte",
    "Hustler",
    "Ignis",
    "Jimny",
    "Jimny Sierra",
    "Jimny Wide",
    "Kei",
    "Kizashi",
    "Landy",
    "MR Wagon",
    "Mighty Boy",
    "Palette",
    "Palette SW",
    "SX4",
    "Solio",
    "Spacia",
    "Spacia Base",
    "Spacia Gear",
    "Splash",
    "Suzuki",
    "Swift",
    "Twin",
    "Wagon R",
    "Wagon R Smile",
    "Wagon R Solio",
    "Wagon R Wide",
    "X-90",
    "XBEE",
    "ｱﾙﾄﾗﾊﾟﾝLC",
    "ｴﾌﾞﾘｲ",
    "ｴﾌﾞﾘｲﾊﾞﾝ",
    "ｴﾌﾞﾘｲﾜｺﾞﾝ",
    "ｷｬﾘｲﾀﾞﾝﾌﾟ 4WD",
    "ｷｬﾘｲﾄﾗｯｸ 4WD",
    "ｼﾞﾑﾆｰ ｼｴﾗ",
    "ｽｲﾌﾄｽﾎﾟｰﾂ",
    "ｽﾍﾟｰｼｱ ｶｽﾀﾑZ",
    "ｿﾘｵ ﾊﾞﾝﾃﾞｨｯﾄ",
    "ﾗﾊﾟﾝLC",
  ],
  daihatsu: [
    "Altis",
    "Atrai Seven",
    "Atrai Van",
    "Atrai Wagon",
    "Bego",
    "Boon",
    "Cast",
    "Charade",
    "Compagno",
    "Coo",
    "Copen",
    "Daihatsu",
    "Delta Truck",
    "Esse",
    "Fellowmax",
    "Hijet Caddie",
    "Hijet Truck",
    "Hijet Van",
    "MAX",
    "Mebius",
    "Midjet II",
    "Mira",
    "Mira Avy",
    "Mira Cocoa",
    "Mira Gino",
    "Mira Tocot",
    "Mira Van",
    "Mira e:s",
    "Move",
    "Move Canbus",
    "Move Conte",
    "Move Latte",
    "Naked",
    "Opti",
    "Pyzar",
    "Rocky",
    "Rugger",
    "Sonica",
    "Storia",
    "Taft",
    "Tanto",
    "Tanto Exe",
    "Terios Kid",
    "Thor",
    "WAKE",
    "YRV",
    "ｸﾞﾗﾝﾏｯｸｽｶｰｺﾞ",
    "ﾀﾝﾄ ｶｽﾀﾑ",
    "ﾃﾘｵｽﾙｷｱ",
    "ﾊｲｾﾞｯﾄｶｰｺﾞ",
    "ﾊｲｾﾞｯﾄｶｰｺﾞ 4WD",
    "ﾊｲｾﾞｯﾄﾃﾞｯｷﾊﾞﾝ",
    "ﾊｲｾﾞｯﾄﾄﾗｯｸ 4WD",
    "ﾐﾗ ｺｺｱ 4WD",
    "ﾐﾗｲｰｽ",
    "ﾑｰｳﾞ ｶｽﾀﾑ",
    "ﾑｰｳﾞ ｷｬﾝﾊﾞｽ",
  ],
  subaru: [
    "Alcyone SVX",
    "BRZ",
    "Chiffon",
    "Dex",
    "Domingo",
    "Exiga",
    "Forester",
    "Impreza",
    "Impreza G4",
    "Impreza Wagon",
    "Justy",
    "Legacy B4",
    "Legacy OutBack",
    "Legacy Wagon",
    "Leone",
    "Levorg",
    "Lucra",
    "Pleo",
    "Pleo Nesta",
    "Pleo Plus",
    "Pleo Van",
    "R1",
    "R2",
    "Rex",
    "Samber Dias Van",
    "Samber Dias Wagon",
    "Samber Truck",
    "Samber Van",
    "Stella",
    "Subaru",
    "Subaru 360",
    "Subaru XV",
    "Traviq",
    "Trezia",
    "Vivio",
    "Vivio Bistro",
    "WRX",
    "WRXSTI",
    "ｲﾝﾌﾟﾚｯｻｱﾈｼｽ",
    "ｲﾝﾌﾟﾚｯｻｽﾎﾟｰﾂ 4WD",
    "ｸﾛｽﾄﾚｯｸ",
    "ｻﾝﾊﾞｰﾄﾗｯｸ 4WD",
  ],
};
